"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _get = _interopRequireDefault(require("lodash/get"));
var _BrixelIcon = _interopRequireDefault(require("./BrixelIcon"));
var _BrixelButtonPrimary = _interopRequireDefault(require("./BrixelButtonPrimary"));
var _BrixelButtonSecondary = _interopRequireDefault(require("./BrixelButtonSecondary"));
var _BrixelButtonText = _interopRequireDefault(require("./BrixelButtonText"));
var _OutsideElement = _interopRequireDefault(require("./OutsideElement"));
var _BrixelButtonIcon = _interopRequireDefault(require("./BrixelButtonIcon"));
var _reactRedux = require("react-redux");
var _translation = _interopRequireDefault(require("../Translation/translation"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const BrixelModal = props => {
  const {
    actions = null,
    background = '',
    bodyActionsClass = '',
    bodyClassColor = '',
    children,
    classContainer = null,
    classHeight = 'min-h-fix-sm-320',
    classImg = null,
    className = '',
    classTitle = '',
    clickOutsideToClose = true,
    color = '',
    containerClassColor = '',
    footerClassColor = 'bgWhite',
    hideHeader = false,
    id = '',
    lang = 'en',
    layout = 'small',
    logo = {},
    multiActions = null,
    multiBodyActions = null,
    onBack = null,
    onClose = null,
    saturation = 400,
    saturationTxt = null,
    showLogoHeader = false,
    title = '',
    titleIcon = null,
    titleImg = null,
    bodyInnerClass = '',
    titleTop = false,
    titleTopClass = '',
    translations,
    coverImg = null
  } = props;
  // STATE
  const elem = (0, _react.useRef)(null);
  const classBackImg = background ? `${background.charAt(0).toUpperCase()}${background.slice(1)}` : '';
  const colorClassSat = `bg${classBackImg}${saturation > 50 ? saturation : ''}`;
  (0, _react.useEffect)(() => {
    if (typeof window !== 'undefined') document.body.classList.add('noOverflows');
    // returned function will be called on component unmount
    return () => {
      if (typeof window !== 'undefined') document.body.classList.remove('noOverflows');
    };
  }, []);
  const renderMultiActions = (btn, i) => {
    switch (btn.btnType) {
      case 'Primary':
        return /*#__PURE__*/_react.default.createElement(_BrixelButtonPrimary.default, {
          disabled: btn.disabled || false,
          key: `btn_${i.toString()}`,
          className: `action ${btn.className || ''}`,
          label: (0, _translation.default)(btn.name, lang, null, translations),
          rounded: btn.round || false,
          onClick: e => btn.func(e),
          theme: btn.bkg || 'primary',
          themeSat: btn.sat || 400,
          isLoading: btn.isLoading || false,
          leftIcon: btn.leftIcon,
          rightIcon: btn.rightIcon
        });
      case 'Secondary':
        return /*#__PURE__*/_react.default.createElement(_BrixelButtonSecondary.default, {
          disabled: btn.disabled || false,
          key: `btnSec_${i.toString()}`,
          className: `action ${btn.className || ''}`,
          label: (0, _translation.default)(btn.name, lang, null, translations),
          rounded: btn.round || false,
          onClick: e => btn.func(e),
          theme: btn.clr || 'primary',
          themeSat: btn.sat || 400,
          isLoading: btn.isLoading || false,
          leftIcon: btn.leftIcon,
          rightIcon: btn.rightIcon
        });
      case 'Tertiary':
        return /*#__PURE__*/_react.default.createElement(_BrixelButtonText.default, {
          disabled: btn.disabled || false,
          key: `btnTxt_${i.toString()}`,
          className: `action ${btn.className || ''}`,
          label: (0, _translation.default)(btn.name, lang, null, translations),
          onClick: e => btn.func(e),
          theme: btn.clr || 'primary',
          themeSat: btn.sat || 400,
          isLoading: btn.isLoading || false,
          leftIcon: btn.leftIcon,
          rightIcon: btn.rightIcon
        });
      case 'Icon':
        return /*#__PURE__*/_react.default.createElement(_BrixelButtonIcon.default, {
          bgTransparent: btn.bgTransparent || false,
          disabled: btn.disabled || false,
          key: `iconTxt_${i.toString()}`,
          className: `action ${btn.className || ''}`,
          label: (0, _translation.default)(btn.name, lang, null, translations),
          onClick: e => btn.func(e),
          theme: btn.clr || 'primary',
          themeSat: btn.sat || 400,
          isLoading: btn.isLoading || false,
          icon: btn.leftIcon || '',
          showBrd: btn.showBrd || false
        });
      default:
        return null;
    }
  };
  (0, _OutsideElement.default)(elem, clickOutsideToClose ? {
    action: 'function',
    func: () => onClose ? onClose() : ''
  } : null);
  const classIconsWrap = onBack || titleTop ? 'jc-b' : 'jc-fe';
  let classWidth = 'w-fix-sm-376';
  if (layout === 'large') classWidth = 'w-fix-sm-480';
  if (layout === 'xlarge') classWidth = 'w-fix-md-624';
  if (layout === 'xxlarge') classWidth = 'w-fix-md-760';
  if (layout === 'fullscreen') classWidth = 'w-perc-100 h-perc-100';
  if (layout === 'fluid') classWidth = '';
  return /*#__PURE__*/_react.default.createElement("div", {
    className: `brixel-modal ${className}`,
    id: id
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: `w-perc-100 ${classHeight} ${layout} ${classWidth} modal-container dis-fl-col ${actions ? 'jc-b' : 'jc-fs'} ${containerClassColor}`,
    ref: elem || ''
  }, !hideHeader && (/*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, showLogoHeader ? (/*#__PURE__*/_react.default.createElement("header", {
    className: "flowHeader"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "dis-f max-h-fix-136 a-c jc-b pos-r pb-1 pt-2 py-sm-5 container mx-a"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "dis-f a-c w-fix-104 min-h-fix-56 h-perc-100"
  }, /*#__PURE__*/_react.default.createElement("img", {
    className: `logo w-perc-100 ${typeof window !== 'undefined' && window.innerWidth <= 600 ? 'w-fix-32 mr-2' : 'max-w-fix-104 ov-h'}`,
    src: `${typeof window !== 'undefined' && window.innerWidth <= 600 ? (0, _get.default)(logo, 'small', '') : (0, _get.default)(logo, 'large', '')}`,
    alt: "Brixel Logo",
    id: "header-logo"
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "dis-f a-c"
  }, /*#__PURE__*/_react.default.createElement(_BrixelButtonIcon.default, {
    bgTransparent: true,
    className: "zIndex11",
    theme: "text",
    icon: "close-small",
    onClick: () => onClose ? onClose() : ''
  }))))) : (/*#__PURE__*/_react.default.createElement("div", {
    className: `modal-header a-c ${coverImg ? 'coverImg' : ''} dis-f ${titleTop ? 'titleTop' : ''} ${titleTopClass} ${classIconsWrap}`
  }, titleTop && title && (/*#__PURE__*/_react.default.createElement("div", {
    className: "modal-title flex-1"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "w-perc-100",
    dangerouslySetInnerHTML: {
      __html: title
    }
  }))), coverImg && (/*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("img", {
    className: 'w-perc-100 imgCover h-fix-200 h-fix-md-304 h-fix-lg-384',
    width: "100%",
    src: coverImg
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: coverImg ? 'pos-a-fix x-r-2 x-t-2' : 'ml-a dis-f a-c'
  }, onBack && (/*#__PURE__*/_react.default.createElement(_BrixelButtonIcon.default, {
    bgTransparent: true,
    theme: "text",
    themeSat: 400,
    onClick: () => onBack(),
    icon: "arrow-simple-left"
  })), onClose && (/*#__PURE__*/_react.default.createElement(_BrixelButtonIcon.default, {
    bgTransparent: true,
    theme: "text",
    themeSat: 400,
    onClick: () => onClose(),
    icon: "close",
    className: titleTop ? 'as-fs' : ''
  }))))))), title && !titleTop && (/*#__PURE__*/_react.default.createElement("div", {
    className: "modal-title"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: `title-container ${classContainer || 'dis-f a-c'}`
  }, titleIcon && (/*#__PURE__*/_react.default.createElement(_BrixelIcon.default, {
    icon: titleIcon,
    className: "title-icon",
    background: background,
    saturation: saturation,
    saturationTxt: saturationTxt || undefined,
    color: color
  })), titleImg && (/*#__PURE__*/_react.default.createElement("div", {
    className: `${classImg || 'w-fix-48 h-fix-48 dis-f a-c jc-c p-1 mr-2 brdRadius'} ${colorClassSat}`
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: titleImg,
    className: "title-img w-perc-100",
    alt: "Title"
  }))), /*#__PURE__*/_react.default.createElement("span", {
    className: `heading3 ${classTitle}`,
    dangerouslySetInnerHTML: {
      __html: title
    }
  })))), /*#__PURE__*/_react.default.createElement("div", {
    className: `modal-body ta-l ${bodyClassColor}`
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: bodyInnerClass
  }, children), multiBodyActions && (/*#__PURE__*/_react.default.createElement("div", {
    className: bodyActionsClass
  }, multiBodyActions.map((btn, i) => renderMultiActions(btn, i))))), actions && (/*#__PURE__*/_react.default.createElement("div", {
    className: `modal-footer dis-f jc-c jc-fe-md ${footerClassColor}`
  }, /*#__PURE__*/_react.default.createElement(_BrixelButtonPrimary.default, {
    className: "action",
    label: actions.name,
    onClick: e => actions.func(e),
    rounded: actions.round || false,
    theme: actions.bkg || 'primary',
    themeSat: actions.sat || 400,
    isLoading: actions.isLoading || false,
    disabled: actions.disabled || false
  }))), multiActions && (/*#__PURE__*/_react.default.createElement("div", {
    className: `modal-footer dis-f jc-b jc-fe-md ${footerClassColor} ${multiActions.length > 1 ? 'jc-b' : 'jc-c'}`
  }, multiActions.map((btn, i) => renderMultiActions(btn, i))))));
};
const mapStateToProps = state => ({
  translations: (0, _get.default)(state, 'translations', {})
});
var _default = exports.default = (0, _reactRedux.connect)(mapStateToProps, null)(BrixelModal);